/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

let checkboxBronze = document.getElementById('Bronze');
let checkboxSilver = document.getElementById('Silver');
let checkboxGold = document.getElementById('Gold');

let checkbox_real = null;

if(checkboxBronze != null) {
  checkbox_real = checkboxBronze;
} else if (checkboxSilver != null) {
  checkbox_real = checkboxSilver;
} else if (checkboxGold != null) {
  checkbox_real = checkboxGold;
}

if(checkbox_real != null) {
  checkbox_real.addEventListener("change", validaCheckbox, false);
  function validaCheckbox()
  {
    let checked = checkbox_real.checked;
    let typeDiscount = "";
    if(checked){
      typeDiscount = checkbox_real.id;
    } else {
      typeDiscount = "Ninguno";
    }

    var url = "https://tupperware.triciclogo.com/webhook/percentageinstantprocess/";

    $.post(url,
    {
      idUser: checkbox_real.value,//{{customer.id}},
      typeDiscount: typeDiscount,
    })
    .done(function(data, status){
      if(data.code == 200) {
        console.log(data);
      }
    })
    .fail(function(xhr, status, error) {
    });
  }
}

let checkboxShippingBronce = document.getElementById('BronzeShippingFree');
if(checkboxShippingBronce != null) {
  checkboxShippingBronce.addEventListener("change", validaCheckboxShipping, false);
  function validaCheckboxShipping()
  {
    let checkedShipping = checkboxShippingBronce.checked;
    let typeDiscountShipping = "";
    if(checkedShipping){
      typeDiscountShipping = "BronzeShippingFree";
    } else {
      typeDiscountShipping = "Ninguno";
    }

    var url = "https://tupperware.triciclogo.com/webhook/percentageinstantprocess/";

    $.post(url,
    {
      idUser: checkbox_real.value,//{{customer.id}},
      typeDiscount: typeDiscountShipping,
    })
    .done(function(data, status){
      if(data.code == 200) {
        console.log(data);
      }
    })
    .fail(function(xhr, status, error) {
    });
  }
}

/* DM - Checkbox TyC y Aviso de Privacidad - Ini */
/*
let checkboxtyc = document.getElementById('agree');
let checkboxap = document.getElementById('agreeAp');

if(checkboxtyc != null && checkboxap != null) {
  
  checkboxtyc.addEventListener("change", validaCheckboxTycAp, false);
  checkboxap.addEventListener("change", validaCheckboxTycAp, false);
  
  function validaCheckboxTycAp()
  {
    let checkedTyc = checkboxtyc.checked;
    let checkedAp = checkboxap.checked;
    let cartCheckout = document.querySelector(".Cart__Checkout");
    
    if(checkedTyc != false && checkedAp != false){
      cartCheckout.disabled = false;
      cartCheckout.title = "";
    } else {
      cartCheckout.disabled = true;
      cartCheckout.title = "Para continuar con tu compra, debes aceptar los Términos y Condiciones y el Aviso de privacidad del sitio";
      alert("Para continuar con tu compra, debes aceptar los Términos y Condiciones y el Aviso de privacidad del sitio");
    }
  }
}
*/
jQuery(function(){
  jQuery(document).on('click', "input[name='checkout']:not(.saso-ignore), input[value='Checkout']:not(.saso-ignore), button[name='checkout']:not(.saso-ignore), [href$='checkout']:not(.saso-ignore), button[value='Checkout']:not(.saso-ignore), input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc']", function(e){
    e.preventDefault();

    if ($('#agree').is(':checked') && $('#agreeAp').is(':checked')) {
      // $(this).submit();
      if (typeof sasoCheckout != "function") {
        window.location = "/checkout";
      }

      jQuery.ajax({
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "GET",
        url: '/cart.js',
        success: function(res) {
          window.saso.cart = res
          sasoCheckout()
        }
      })
    }
    else {
      alert("Debes seleccionar que estás de acuerdo con los términos y condiciones para continuar.");
      return false;
    }

  });
});
/* DM - Checkbox TyC y Aviso de Privacidad - Fin */